var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-slider",
      class: [
        _vm.sizeCss,
        { "is-range": _vm.showRange, "v-slider--disabled": _vm.isDisabled },
      ],
    },
    [
      _vm.showInput
        ? _c("v-input-number", {
            ref: "input",
            staticClass: "v-slider__number",
            class: { "v-slider__number--controls": _vm.showInputControls },
            attrs: {
              min: _vm.min,
              max: _vm.max,
              disabled: _vm.isDisabled,
              "is-controls": _vm.showInputControls,
              precision: _vm.precisionVal,
              size: _vm.size,
              step: _vm.step,
            },
            on: { change: _vm.changeValue },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          })
        : _vm._e(),
      _vm.showInput !== false
        ? _c("span", {
            ref: "endRange1",
            staticClass: "v-slider-text-space",
            class: { "show-input": _vm.showInput },
          })
        : _vm._e(),
      _vm.showRange !== false
        ? _c(
            "span",
            {
              ref: "startRange",
              staticClass: "v-slider-range v-slider-range--left",
            },
            [_vm._v(" " + _vm._s(_vm.min))]
          )
        : _vm._e(),
      _vm.showRange !== false
        ? _c(
            "span",
            {
              ref: "endRange",
              staticClass: "v-slider-range v-slider-range--right",
              class: { "show-input": _vm.showInput },
            },
            [_vm._v(" " + _vm._s(_vm.max))]
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "line",
          staticClass: "v-slider-line",
          style: {
            "margin-left": _vm.rangeMarginLeft + "px",
            "margin-right": _vm.rangeMarginRight + "px",
          },
          on: { click: _vm.handlerClickLine },
        },
        [
          _c("div", {
            staticClass: "v-slider-line__inner",
            style: { width: _vm.leftPercent + "%" },
          }),
          _c(
            "div",
            {
              ref: "bar",
              staticClass: "v-slider-line__content",
              style: { left: _vm.leftPercent + "%" },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.mouseStart.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                staticClass: "v-slider-line__bar",
                class: { "v-slider-line__bar--active": _vm.moveStart },
                on: {
                  mouseenter: function ($event) {
                    _vm.isMouseOver = true
                  },
                  mouseleave: function ($event) {
                    _vm.isMouseOver = false
                  },
                },
              }),
              _vm.showTooltip
                ? [
                    _vm.moveStart || _vm.isMouseOver
                      ? _c("slider-popups", {
                          staticClass: "v-slider-line__popper",
                          attrs: { value: _vm.format(_vm.inputValue) },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }